import { Navigate, useRoutes } from 'react-router-dom';
// okta
import { LoginCallback } from '@okta/okta-react';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
// pages
import { Page404, Main } from './elements';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/main',
      element: (
        <AuthGuard>
          <Main />
        </AuthGuard>
      ),
      children: [{ path: '', element: <Main /> }],
    },
    {
      element: <CompactLayout />,
      children: [{ path: '404', element: <Page404 /> }],
    },
    {
      path: 'login/callback',
      element: <LoginCallback />,
    },
    { path: '*', element: <Navigate to="/main" replace /> },
  ]);
}
